<div class="filter-bar">
    <div class="bar-left">
        <!-- Filter popover (STN rebuild 2026-08): FILTER BY toggles + TIME ZONE
             and US STATE facet groups. Multi-select; honest blanks never excluded. -->
        <div class="menu-anchor">
            <button
                type="button"
                class="chip"
                data-testid="filter-trigger"
                [class.active]="activeFilterCount > 0"
                [class.open]="openMenu === 'filter'"
                [attr.aria-expanded]="openMenu === 'filter'"
                aria-haspopup="true"
                (click)="ToggleMenu('filter')">
                <svg class="chip-icon" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M1.5 3h13M3.5 8h9M6 13h4" fill="none" stroke="currentColor"
                          stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Filter</span>
                <span class="count" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
            </button>

            <div class="popover popover--filters" *ngIf="openMenu === 'filter'" data-testid="filter-popover">
                <fieldset>
                    <legend>Filter by</legend>
                    <label *ngFor="let opt of attributeOptions">
                        <input
                            type="checkbox"
                            [checked]="IsAttributeOn(opt.key)"
                            (change)="ToggleAttribute(opt.key, $any($event.target).checked)" />
                        <span>{{ opt.label }}</span>
                    </label>
                </fieldset>

                <fieldset *ngIf="facets.timezones.length > 0">
                    <legend>Time zone</legend>
                    <label *ngFor="let tz of facets.timezones">
                        <input
                            type="checkbox"
                            [checked]="IsTimezoneOn(tz.key)"
                            (change)="ToggleTimezone(tz.key, $any($event.target).checked)" />
                        <span>{{ tz.label }}</span>
                        <span class="facet-count">{{ tz.count }}</span>
                    </label>
                </fieldset>

                <fieldset *ngIf="facets.states.length > 0">
                    <legend>US state</legend>
                    <label *ngFor="let st of facets.states">
                        <input
                            type="checkbox"
                            [checked]="IsStateOn(st.code)"
                            (change)="ToggleState(st.code, $any($event.target).checked)" />
                        <span>
                            {{ st.label }}
                            <em class="office-tag" *ngIf="st.code === officeStateCode">office state</em>
                        </span>
                        <span class="facet-count">{{ st.count }}</span>
                    </label>
                </fieldset>

                <button
                    type="button"
                    class="clear-link"
                    *ngIf="activeFilterCount > 0"
                    (click)="ClearFilters()">
                    Clear all
                </button>
            </div>
        </div>

        <!-- Sort popover -->
        <div class="menu-anchor">
            <button
                type="button"
                class="chip"
                [class.open]="openMenu === 'sort'"
                [attr.aria-expanded]="openMenu === 'sort'"
                aria-haspopup="true"
                (click)="ToggleMenu('sort')">
                <svg class="chip-icon" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M4.5 2.5v11M4.5 13.5l-2.2-2.2M4.5 13.5l2.2-2.2M11.5 13.5v-11M11.5 2.5l-2.2 2.2M11.5 2.5l2.2 2.2"
                          fill="none" stroke="currentColor" stroke-width="1.4"
                          stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Sort: {{ sortLabel }}</span>
            </button>

            <div class="popover" *ngIf="openMenu === 'sort'">
                <button
                    type="button"
                    class="menu-item"
                    *ngFor="let opt of sortOptions"
                    [class.selected]="opt.value === sortKey"
                    (click)="SelectSort(opt.value)">
                    <span>{{ opt.label }}</span>
                    <svg *ngIf="opt.value === sortKey" class="check" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor"
                              stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Active filter chips (removable) -->
        <button
            type="button"
            class="chip active applied"
            *ngFor="let chip of activeChips"
            [attr.aria-label]="'Remove filter ' + chip.label"
            (click)="chip.remove()">
            <span>{{ chip.label }}</span>
            <span class="remove" aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="bar-right">
        <ng-content></ng-content>
    </div>
</div>
